import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Row, Col, Divider, Button, Icon, List, Avatar, Collapse} from 'antd';
import * as moment from 'moment';

const Panel = Collapse.Panel;

import {
    fetchContractorBusiness,
    fetchContractorEngineers,
    syncContractorBusiness,
    syncContractorEngineers,
} from '../../actions';

class GasSafe extends Component {
    constructor(props) {
        super(props);
        this.state = {isSyncing: false};
    }
    componentDidMount() {
        const {
            contractor_id,
            fetchContractorBusiness,
            fetchContractorEngineers,
        } = this.props;

        return Promise.all([
            fetchContractorBusiness(contractor_id),
            fetchContractorEngineers(contractor_id),
        ]);
    }
    render() {
        const {
            contractor_id,
            regNo,
            business: {
                business_name,
                premises,
                street,
                town,
                post_code,
                telephone,
                areas_of_work_domestic,
                areas_of_work_non_domestic,
            },
            engineers: {data: engineers, isFetching},
            syncContractorBusiness,
            syncContractorEngineers
        } = this.props;
        const sync = () => {
            this.setState({isSyncing: true});
            return Promise.all([
                syncContractorBusiness(contractor_id),
                syncContractorEngineers(contractor_id)
            ]).then(() => {
                this.setState({isSyncing: false});
            })
        };
        const extra = () => {
            return <Button onClick={sync}><Icon type="sync" spin={this.state.isSyncing}/> Sync from Gas Safe Register</Button>;
        };
        const renderItem = item => {
            if (isFetching) return <span/>;

            const {id, profile_photo, first_name, last_name} = item;
            const gsrDiff = moment(item.card_expiry_date.date, 'YYYY-MM-DD').diff(moment(), 'days');
            let gsrStatus = '#52c41a';
            if (gsrDiff < 0) {
                gsrStatus = '#f5222d';
            } else if (gsrDiff < 30) {
                gsrStatus = '#faad14'
            }

            const description = () => (
                <span>
                    Card Expiry Date: {moment(item.card_expiry_date.date, 'YYYY-MM-DD').format('DD/MM/YYYY')}
                    <Divider type="vertical" />
                    Engineer Card No: {item.engineer_card_no}
                </span>
            );

            return (
                <List.Item style={{paddingLeft: 12, paddingRight: 12}}>
                    <List.Item.Meta
                        avatar={<Avatar src={profile_photo} style={{
                            width: 48,
                            height: 48,
                            borderRadius: 25,
                            borderColor: gsrStatus,
                            borderStyle: 'solid',
                            borderWidth: 1
                        }}/>}
                        title={`${first_name} ${last_name}`}
                        description={description()}
                    />
                </List.Item>
            );
        };
        const renderAreaOfWork = (type) => (area, key) => {
            const {Name, SubCategories} = area;
            const subList = Array.isArray(SubCategories.string) ? SubCategories.string.map((name, i) => {
                return <li key={i}>{name}</li>;
            }) : <li>{SubCategories.string}</li>;
            return (
                <Panel header={Name} key={type + key}>
                    <ul>
                        {subList}
                    </ul>
                </Panel>
            )
        };
        return (
            <div>
                <Card title="Gas Safe" extra={extra()} bordered={false}>
                    <Row gutter={16}>
                        <Col md={{span: 12}}>
                            <Divider orientation="left">Business Information</Divider>
                            <Row gutter={16}>
                                <Col span={8}>Gas Safe Registration Number</Col>
                                <Col>{regNo || '-'}</Col>
                            </Row>
                            <Row gutter={16}>
                                <Col span={8}>Business Name</Col>
                                <Col>{business_name || '-'}</Col>
                            </Row>
                            <Row gutter={16}>
                                <Col span={8}>Premises</Col>
                                <Col>{premises || '-'}</Col>
                            </Row>
                            <Row gutter={16}>
                                <Col span={8}>Street</Col>
                                <Col>{street || '-'}</Col>
                            </Row>
                            <Row gutter={16}>
                                <Col span={8}>Town</Col>
                                <Col>{town || '-'}</Col>
                            </Row>
                            <Row gutter={16}>
                                <Col span={8}>Post Code</Col>
                                <Col>{post_code || '-'}</Col>
                            </Row>
                            <Row gutter={16}>
                                <Col span={8}>Telephone</Col>
                                <Col>{telephone || '-'}</Col>
                            </Row>
                            <Divider orientation="left">Permitted Areas of Works</Divider>
                            <Collapse accordion bordered={false}>
                                {areas_of_work_domestic && areas_of_work_domestic.map(renderAreaOfWork('domestic'))}
                                {areas_of_work_non_domestic && areas_of_work_non_domestic.map(renderAreaOfWork('nonDomestic'))}
                            </Collapse>
                        </Col>
                        <Col md={{span: 12}}>
                            <Divider orientation="left">Card Holders</Divider>
                            <List
                                itemLayout="horizontal"
                                dataSource={engineers}
                                renderItem={renderItem}
                            />
                        </Col>
                    </Row>
                </Card>
            </div>
        );
    }
}


const mapStateToProps = (state, ownProps) => {
    const engineers = state.contractor.engineers;
    const business = state.contractor.business;

    return {
        regNo: state.me.gas_safe_number,
        contractor_id: state.me.contractor_id,
        contractor: {...state.contractor.profile},
        engineers: {...engineers},
        business: {...business}
    };
};

export default connect(mapStateToProps, {
    fetchContractorBusiness,
    fetchContractorEngineers,
    syncContractorBusiness,
    syncContractorEngineers
})(GasSafe);


// WEBPACK FOOTER //
// ./resources/assets/js/components/contractor/GasSafe.js